import {
  CurrentUserDto,
  SettingsDto,
  TierDto,
  UserLoyaltyInfoDto,
  UserVerificationLevelDto,
  VerificationLimitsDto,
} from 'common/api/autogenerated/client-area';
import { PriceType } from 'common/api/autogenerated/trading-gateway';

import { defaultVerificationLimits } from 'common/hooks/useCustomer/useCustomer.constants';

const userInitialState: CurrentUserDto & {
  loading: boolean;
  tier: UserLoyaltyInfoDto;
  tiers: TierDto[];
  settings: SettingsDto;
  priceType?: PriceType;
  verificationLimits: VerificationLimitsDto;
  intermediateVerificationLevelStatus: UserVerificationLevelDto;
  isMerchant: boolean;
} = {
  isAuthenticated: false,
  isMerchant: false,
  loading: true,
  defaultCurrency: 'USD',
  verificationLimits: defaultVerificationLimits,
  intermediateVerificationLevelStatus: {},
  tier: {},
  tiers: [],
  settings: {},
};

export { userInitialState };
